import { render, staticRenderFns } from "./fundActivities.vue?vue&type=template&id=58a7a130&scoped=true&"
import script from "./fundActivities.vue?vue&type=script&lang=js&"
export * from "./fundActivities.vue?vue&type=script&lang=js&"
import style0 from "./fundActivities.vue?vue&type=style&index=0&id=58a7a130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7a130",
  null
  
)

export default component.exports